module.exports = __webpack_public_path__ + "static/media/k_of_diamonds2.11b5ca26.png";